import ExtensionContainer from '@components/ExtensionContainer'
import { IdleTimer } from '@components/IdleTimer'
import LockGuard from '@components/LockGuard'
import { router } from '@components/Router/Router'
import Toast from '@components/Toast'
import { WalletFundedTracker } from '@components/WalletFundedTracker'
import { initializeSentry } from '@core/sentry'
import BalanceProvider from '@plug-core/providers/BalanceProvider'
import ConfigProvider from '@plug-core/providers/ConfigProvider'
import { GoogleAnalyticsProvider } from '@plug-core/providers/GoogleAnalyticsProvider'
import LiquidiumProvider from '@plug-core/providers/LiquidiumProvider'
import WalletProvider from '@plug-core/providers/WalletProvider'
import { initializeI18n } from '@plug-core/utils/initializeI18n'
import { AppearanceProvider } from '@providers/AppearanceProvider'
import FindTokensProvider from '@providers/FindTokensProvider'
import { MobileSidebarProvider } from '@providers/MobileSidebarProvider'
import { SpotlightProvider } from '@providers/SpotlightProvider'
import StatusPillProvider from '@providers/StatusPillProvider'
import ToastProvider from '@providers/ToastProvider'
import React from 'react'
import { initReactI18next } from 'react-i18next'
import { RouterProvider } from 'react-router-dom'
import { enLocalisation } from './locales/en'

initializeI18n(initReactI18next, enLocalisation)
initializeSentry()

export const App = () => {
  return (
    <AppearanceProvider>
      <ExtensionContainer>
        <ConfigProvider>
          <ToastProvider>
            <StatusPillProvider>
              <GoogleAnalyticsProvider>
                <FindTokensProvider>
                  <IdleTimer />
                  <LockGuard>
                    <WalletProvider>
                      <BalanceProvider>
                        <WalletFundedTracker />
                        <LiquidiumProvider>
                          <SpotlightProvider>
                            <MobileSidebarProvider>
                              <RouterProvider router={router} />
                            </MobileSidebarProvider>
                          </SpotlightProvider>
                        </LiquidiumProvider>
                      </BalanceProvider>
                    </WalletProvider>
                  </LockGuard>
                </FindTokensProvider>
              </GoogleAnalyticsProvider>
            </StatusPillProvider>

            <Toast />
          </ToastProvider>
        </ConfigProvider>
      </ExtensionContainer>
    </AppearanceProvider>
  )
}
